import { HotelReserveRecommendationPropertiesTypes } from "@website/accommodation-ui/hotel-reserve-recommendation/hotel-reserve-recommendation.types";
import { MaterialIcon } from "@website/icons/material";
import { CarouselV2 } from "@website/ui/carousel";
import { deepCompare } from "@website/utils/deep-compare";
import omit from "lodash-es/omit";
import { useRouter } from "next/router";
import { memo } from "react";
import { HotelCard } from "../hotel-card-new";

const Component = ({
  hotelRecommendation
}: HotelReserveRecommendationPropertiesTypes) => {
  const router = useRouter();
  if (!hotelRecommendation?.length) return null;

  const handleShowAllClick = () =>
    router.push({
      pathname: "/[cityTitle]",
      query: {
        ...omit(router.query, "hotelTitle"),
        stars: hotelRecommendation?.[0]?.hotelDetail?.stars
      }
    });

  return (
    <div className="flex flex-col gap-4" id="hotel_recomendation">
      <div className="flex flex-col gap-2">
        <div className="flex flex-row items-center justify-between">
          <div>
            <div>
              <MaterialIcon
                className="text-on-surface-medium-emphasis scale-150"
                name="apartment"
              />
              <span className="text-subtitle-1 md:text-headline-6 pr-2 ltr:pl-2">
                هتل های مشابه
              </span>
            </div>
          </div>
          <div onClick={handleShowAllClick}>
            <div className="text-secondary text-subtitle-2 hidden cursor-pointer xl:block">
              مشاهده همه
            </div>
          </div>
        </div>
      </div>
      {hotelRecommendation?.length > 0 && (
        <CarouselV2
          hasNavigation={false}
          itemClass="pb-2"
          keyCarousel="hotelRecommendation"
          list={hotelRecommendation.map((recommendationHotel, index) => (
            <div
              className={`h-full ${
                hotelRecommendation?.length > 4 ? "w-[300px]" : "w-[300px]"
              } px-2`}
              key={recommendationHotel.id}
            >
              <HotelCard
                hotelInfo={recommendationHotel}
                index={index + 1}
                replace
                size="small"
                showCarousel={false}
              />
            </div>
          ))}
          mode="snap"
          options={{
            slides: {
              perView: "auto",
              spacing: 1
            }
          }}
        />
      )}
    </div>
  );
};
export const HotelReserveRecommendation = memo(Component, deepCompare);
